import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "開始" },
  { value: 2, text: "休眠" },
  { value: 3, text: "中止" },
]);
